import React, { Component } from 'react';

import './checkbox.css';
import { bool, string } from 'prop-types';

import { CheckboxAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, expression } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, defaultClasses, shallowCompare } from '@philips-emr/tws-utils';

import { ReactComponent as CheckMark } from '../../../resources/assets/components/DLS_Checkmark.svg';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: CheckboxAPI })
class Checkbox extends Component {

  static propTypes = {
    className: string,
    enabled: bool,
    focused: bool,
    label: expression,
    name: string,
    onBlur: eventListener,
    onChange: eventListener,
    onFocus: eventListener,
    readOnly: bool,
    uuid: string,
    value: bool,
  };

  static defaultProps = {
    enabled: true,
    value: false,
    label: 'Checkbox',
  };

  onChange = ({ currentTarget }) => {
    const { onChange, value } = this.props;

    onChange && onChange({ value: currentTarget.checked, oldValue: value });
  };

  onFocus = () => {
    const { onFocus } = this.props;

    onFocus && onFocus();
  };

  onBlur = () => {
    const { onBlur } = this.props;

    onBlur && onBlur();
  };

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this.props, nextProps, [
      'className',
      'enabled',
      'focused',
      'label',
      'name',
      'readOnly',
      'uuid',
      'value',
    ]);
  }

  componentDidUpdate(prevProps) {
    const { focused } = this.props;

    if (prevProps.focused !== focused && focused) {
      this.checkboxRef.focus();
    }
  }

  render() {
    const { uuid, name, label, value, enabled, className, readOnly } = this.props;

    const rootClasses = {
      'c-checkbox': true,
      'is-checked': value,
      [className] : className,
      ...defaultClasses(this.props),
    };

    return (
      <div className={classNames(rootClasses)}>
        <input
          type="checkbox"
          className="c-checkbox__input"
          checked={value}
          disabled={readOnly || !enabled}
          id={`check-${uuid || name}`}
          name={name}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          onChange={this.onChange}
          ref={(ref) => (this.checkboxRef = ref)}
        />

        <label className="c-checkbox__label" htmlFor={`check-${uuid || name}`}>
          <div className="c-checkbox__box" x-contrast="bg"><CheckMark className="c-checkbox__icon" /></div>
          {label && <span>{msg(label)}</span>}
        </label>
      </div>
    );
  }
}

export default Checkbox;
